/* eslint-disable import/no-anonymous-default-export */
import React, { useState, useEffect, useMemo } from 'react';
import { Tooltip, Typography, Menu, MenuItem, ListItemIcon, ListItemText, Icon } from '@mui/material';
import useStyles from './TaskBanner.styles';
import { get, size, uniqBy, last } from 'global/lib/lodash';
import { getTaskTypeIcon, groupTaskTypesByMode } from '../../task/task-type-utils';
import ReassignModal from '../../task/TaskNotify/ReassignModal';
import useRetrieveData from 'global/hooks/useRetrieveData';
import { userHasPermissions } from 'redux/actions/userLogin';
import { Loader } from 'global/styles';
import { useUser } from 'global/hooks/useUser';
import clsx from 'clsx';
import { Row } from 'global/components/row';
import ShareModal from '../../task/TaskNotify/ShareModal';
import sendData from 'redux/actions/sendData';
import { createAppUrl, stringObj } from '../../../global/utils';
import { Button } from 'global/components/Button';
import { Checkbox } from '../../../global/components/checkbox';
import { useTaskTypes } from '../../task/task-type-utils/useTaskTypes';
import { getAvailableTaskTypes, getAvailableTaskTypesForTier } from '../../task/task-type-utils';
import { findTaskForItem, findTasksForItem } from './utils';
import { AUTOTAG } from './index';
import { useDispatch } from 'react-redux';
import { addNewTask } from 'redux/actions/view';
import { CreateModal } from '../../task/CreateModal';
import { cleanCopy } from '../../../global/utils';

const SELECTALL = 'SELECT_ALL';

export default (props) => {
  const { assessment, realm_id, selectedItems, setSelectedItems, visible, disabled, allItems, itemPasses, showSelectBoxes, setShowSelectBoxes, assessmentTasks, updateAssessmentTasks, tasksEnabled = true } = props;
  const classes = useStyles();
  const [amt, setAmt] = useState({ checkpoints: 0, total: 0 });
  const [showModal, setShowModal] = useState({ open: false });
  const [oboQueue, setOboQueue] = useState([]);
  const [oboIndex, setOboIndex] = useState(0);
  const [oboOpen, setOboOpen] = useState(false);
  const { me } = useUser();
  const reduxDispatch = useDispatch();
  const [userParams] = useState({
    waitFor: props.realm_id,
    build: ['users'],
    params: { filter: { content_realm_id: props.realm_id } },
    useCache: { reload: 1 },
  });
  const [shareLoading, setShareLoading] = useState(false);
  const [shareModal, setShareModal] = useState({ open: false });
  const [typeMenuAnchor, setTypeMenuAnchor] = useState(null);
  const { data: taskTypesData } = useTaskTypes();
  const realmTier = get(assessment, 'realm.tier');
  const availableTypes = getAvailableTaskTypesForTier(getAvailableTaskTypes(taskTypesData), realmTier);
  const singleTypeName = availableTypes.length === 1 ? availableTypes[0].name : null;

  const users = useRetrieveData({ url: '/users' }, userParams);

  const getAmt = () => {
    const checkpoints = Object.keys(selectedItems).filter((k) => get(selectedItems, [k, 'itemType']) === 'checkpoint');
    const notSelectAll = Object.keys(selectedItems).filter((k) => get(selectedItems, [k, 'id']) !== SELECTALL);
    const checksize = size(checkpoints);

    let totalAmt = 0;

    const checkChildren = (item) => {
      const passed = itemPasses(item);
      if (item.children) {
        item.children.map(checkChildren);
      }
      if (passed) {
        totalAmt += 1;
      }
    };

    allItems.map(checkChildren);

    return {
      checkpoints: checksize,
      selCheckpoints: checkpoints,
      total: totalAmt,
      totalSelected: size(notSelectAll),
      selectAll: Object.keys(selectedItems).find((k) => get(selectedItems, [k, 'id']) == SELECTALL),
    };
  };

  useEffect(() => {
    setAmt(getAmt());
  }, [selectedItems, allItems]);

  const { taskedCount, untaskedCount } = useMemo(() => {
    const checkpoints = Object.keys(selectedItems)
      .filter((k) => get(selectedItems, [k, 'itemType']) === 'checkpoint')
      .map((k) => selectedItems[k]);
    let tasked = 0;
    let untasked = 0;
    checkpoints.forEach((cp) => {
      const hasTask = (() => {
        if (size(get(cp, 'subscores'))) {
          const qualifying = cp.subscores.filter(ss =>
            get(ss, 'notes') !== AUTOTAG && (!!get(ss, 'notes') || !!size(get(ss, 'images', [])))
          );
          if (!size(qualifying)) return !!findTaskForItem(cp, assessmentTasks);
          return qualifying.every(ss => !!findTaskForItem(ss, assessmentTasks));
        }
        return !!findTaskForItem(cp, assessmentTasks);
      })();
      if (hasTask) tasked++;
      else untasked++;
    });
    return { taskedCount: tasked, untaskedCount: untasked };
  }, [selectedItems, assessmentTasks]);

  const isMixed = taskedCount > 0 && untaskedCount > 0;

  const shareTasks = () => {
    const checkpoints = Object.keys(selectedItems)
      .filter((k) => get(selectedItems, [k, 'itemType']) === 'checkpoint')
      .map((k) => selectedItems[k]);
    checkpoints.forEach((cp) => {
      if (size(get(cp, 'subscores'))) {
        const qualifying = cp.subscores.filter(ss =>
          get(ss, 'notes') !== AUTOTAG && (!!get(ss, 'notes') || !!size(get(ss, 'images', [])))
        );
        if (!size(qualifying)) {
          const existingTasks = findTasksForItem(cp, assessmentTasks);
          existingTasks.forEach((existingTask) => {
            reduxDispatch(addNewTask({ ...existingTask, fromExisting: true }));
          });
        } else {
          qualifying.forEach((ss) => {
            const existingTasks = findTasksForItem(ss, assessmentTasks);
            existingTasks.forEach((existingTask) => {
              reduxDispatch(addNewTask({ ...existingTask, fromExisting: true }));
            });
          });
        }
      } else {
        const existingTasks = findTasksForItem(cp, assessmentTasks);
        existingTasks.forEach((existingTask) => {
          reduxDispatch(addNewTask({ ...existingTask, fromExisting: true }));
        });
      }
    });
    setSelectedItems({});
    setShowSelectBoxes(false);
  };

  const flattenCheckpoints = () => {
    const items = cleanCopy(selectedItems);
    const queue = [];
    Object.keys(items).forEach((k) => {
      const item = get(items, k);
      if (item && item.itemType === 'checkpoint') {
        if (size(get(item, 'subscores'))) {
          item.subscores.forEach((ss) => {
            if (get(ss, 'notes') !== AUTOTAG && (!!get(ss, 'notes') || !!size(get(ss, 'images', [])))) {
              queue.push({ checkpoint: ss, checklist: item.checklist || ss.checklist });
            }
          });
        } else {
          queue.push({ checkpoint: item, checklist: item.checklist });
        }
      }
    });
    return queue;
  };

  const [oboType, setOboType] = useState(null);

  const startOneByOne = (selectedType) => {
    const queue = flattenCheckpoints().filter(({ checkpoint }) => !findTaskForItem(checkpoint, assessmentTasks));
    if (!size(queue)) return;
    setOboType(selectedType || null);
    setOboQueue(queue);
    setOboIndex(0);
    setOboOpen(true);
  };

  const onOboClose = async (created) => {
    if (created && updateAssessmentTasks) {
      await updateAssessmentTasks();
    }
    const nextIndex = oboIndex + 1;
    if (created && nextIndex < oboQueue.length) {
      setOboIndex(nextIndex);
    } else {
      // Done or cancelled - close the sequence
      setOboOpen(false);
      setOboQueue([]);
      setOboIndex(0);
      if (created) {
        setSelectedItems({});
        setShowSelectBoxes(false);
      }
    }
  };

  const addTasks = (selectedType) => {
    const typeToUse = selectedType || (availableTypes.length === 1 ? availableTypes[0] : null);
    const isOneByOne = typeToUse && get(typeToUse, 'multi_select_behavior') === 'one_by_one';

    if (isOneByOne) {
      startOneByOne(typeToUse);
      return;
    }

    const assignee = get(props, 'assessment.assignees.0', me);
    const assignees = uniqBy([assignee, ...(users.data || [])], 'id');

    // Filter out checkpoints/subscores that already have tasks
    const filteredItems = {};
    Object.keys(selectedItems).forEach((k) => {
      const item = selectedItems[k];
      if (!item || item.itemType !== 'checkpoint') {
        filteredItems[k] = item;
        return;
      }
      if (size(get(item, 'subscores'))) {
        const remaining = item.subscores.filter((ss) => {
          if (get(ss, 'notes') === AUTOTAG || (!get(ss, 'notes') && !size(get(ss, 'images', [])))) return false;
          return !findTaskForItem(ss, assessmentTasks);
        });
        if (size(remaining)) {
          filteredItems[k] = { ...item, subscores: remaining };
        }
      } else {
        if (!findTaskForItem(item, assessmentTasks)) {
          filteredItems[k] = item;
        }
      }
    });

    setShowModal({
      open: true,
      title: typeToUse ? `Create ${typeToUse.name}s` : 'Create Tasks',
      okButton: 'Create',
      tasks: [{ assignees: [assignee] }],
      selectedItems: filteredItems,
      showTrades: true,
      showTaskTypeSelector: false,
      availableTaskTypes: typeToUse ? [typeToUse] : availableTypes,
      onFormSubmit: props.onCreateTasks,
      assignees: assignees,
      onClose: () => {
        setShowModal({ open: false });
        document.getElementsByTagName('body')[0].style = '';
      },
    });
  };

  const printTasks = async () => {
    try {
      if (shareLoading) {
        return;
      }

      setShareLoading(true);

      const checkpoints = Object.keys(selectedItems)
        .filter((k) => get(selectedItems, [k, 'itemType']) === 'checkpoint')
        .map((k) => selectedItems[k]);
      const scorecard_score_ids = [];
      const sub_score_ids = [];

      checkpoints.map((cp) => {
        const { isSubScore } = cp;
        const scid = `${get(cp, `scorecardScoreId`)}`;
        if (isSubScore) {
          sub_score_ids.push(cp.id);
        } else {
          scorecard_score_ids.push(scid);
        }
      });

      const assessment_id = get(assessment, 'id');
      const assessment_name = get(assessment, 'name');

      const relationships = {
        scorecardScores: {
          data: scorecard_score_ids.map(id => ({ type: 'scorecard-scores', id: id.toString() }))
        },
        subScores: !size(sub_score_ids) ? undefined : {
          data: sub_score_ids.map(id => ({ type: 'sub-scores', id: id.toString() })),
        }
      }

      const result = await sendData(
        {
          url: `/messages`,
          method: 'post',
          data: {
            data: {
              type: 'messages',
              attributes: stringObj({
                model_type: 'assessment',
                model_id: assessment_id,
                realm_id,
                status: 1,
                body: 'Test',
              }),
              relationships,
            },
          },
        },
        { normalize: { build: ['messages'] }, params: { include: 'media' } }
      );

      const link = get(last(result), `media.0.full7DayUrl`);

      setShareModal({
        open: true,
        link,
        isScorePdf: true,
        title: 'Share Score PDF',
        tasks: [],
        emailText: `Assessment scores from ${assessment_name} have been shared with you. Please review the PDF here: 

${link}

See the entire Assessment here:

${createAppUrl('')}

Thanks,
`,
      });
    } catch (err) {
      console.error(err);
    } finally {
      setShareLoading(false);
      setSelectedItems({});
      setShowSelectBoxes(false);
    }
  };

  const hasPerms = userHasPermissions('createTasks');
  const isZero = amt.checkpoints === 0;
  const indeterminate = !isZero && amt.totalSelected < amt.total;
  const isChecked = amt.totalSelected >= amt.total && amt.totalSelected > 0;

  const onCheckChange = (e) => {
    props.selectItem({
      id: SELECTALL,
      selectAll: indeterminate || isChecked ? false : true,
      checked: e.target.checked,
      value: 100,
      notes: ' ',
    });
  };

  return !visible ? null : (
    <>
      <div className={clsx(classes.container, !showSelectBoxes && classes.containerNone, disabled && classes.disabled)}>
        <div className={classes.innerContainer}>
          <Checkbox classes={{ root: classes.checkbox }} checkProps={{ indeterminate, disabled }} checked={isChecked} onChange={onCheckChange} color="default" />
          <Typography variant="body2">{!showSelectBoxes ? '' : `${amt.checkpoints} items selected`}</Typography>
          <Row style={{ marginLeft: 'auto' }}>
            {showSelectBoxes && tasksEnabled && (
              <>
                {users.loading ? (
                  <span className={classes.addButton}>
                    <span>Loading Users... <Loader size={16} /></span>
                  </span>
                ) : (
                  <>
                    {(untaskedCount > 0 || taskedCount === 0) && (
                      <Tooltip arrow placement="top" title={!hasPerms ? 'You do not have access to create tasks' : (singleTypeName ? `Create ${singleTypeName}s` : 'Create Tasks')}>
                        <span className={classes.addButton}>
                          <Button
                            disabled={disabled || isZero || !hasPerms}
                            color="secondary"
                            variant="contained"
                            onClick={(e) => {
                              if (size(availableTypes) > 1) {
                                setTypeMenuAnchor(e.currentTarget);
                              } else {
                                addTasks();
                              }
                            }}
                            endIcon={size(availableTypes) > 1 ? <Icon>arrow_drop_down</Icon> : undefined}
                          >
                            {(singleTypeName ? `CREATE ${singleTypeName.toUpperCase()}S` : 'CREATE TASKS') + (isMixed ? ` (${untaskedCount})` : '')}
                          </Button>
                        </span>
                      </Tooltip>
                    )}
                    {taskedCount > 0 && (
                      <Tooltip arrow placement="top" title="Share existing tasks">
                        <span className={classes.addButton}>
                          <Button disabled={disabled || isZero} color="secondary" variant="contained" onClick={shareTasks}>
                            {(singleTypeName ? `SHARE ${singleTypeName.toUpperCase()}S` : 'SHARE TASKS') + (isMixed ? ` (${taskedCount})` : '')}
                          </Button>
                        </span>
                      </Tooltip>
                    )}
                  </>
                )}
              </>
            )}
            {showSelectBoxes && (
              <Tooltip arrow placement="top" title={'Print Items'}>
                <span className={classes.addButton}>
                  {users.loading ? (
                    <span>
                      Loading Users... <Loader size={16} />
                    </span>
                  ) : (
                    <Button disabled={isZero} loading={shareLoading} color="secondary" variant="contained" onClick={printTasks}>
                      {'PRINT ITEMS'}
                    </Button>
                  )}
                </span>
              </Tooltip>
            )}
          </Row>
        </div>
      </div>

      <Menu
        anchorEl={typeMenuAnchor}
        open={Boolean(typeMenuAnchor)}
        onClose={() => setTypeMenuAnchor(null)}
      >
        {(() => {
          const typeGroups = groupTaskTypesByMode(availableTypes);
          const renderItem = (tt) => (
            <MenuItem
              key={tt.id}
              onClick={() => {
                setTypeMenuAnchor(null);
                addTasks(tt);
              }}
            >
              <ListItemIcon sx={{ minWidth: 32 }}>
                <Icon fontSize="small">{getTaskTypeIcon(tt)}</Icon>
              </ListItemIcon>
              <ListItemText>{(tt.name || '').toUpperCase()}</ListItemText>
            </MenuItem>
          );
          if (typeGroups.grouped) {
            return typeGroups.groups.flatMap((group) => [
              <MenuItem key={group.label} disabled sx={{ opacity: '0.7 !important', fontSize: 12 }}>
                {group.label}
              </MenuItem>,
              ...group.items.map(renderItem),
            ]);
          }
          return availableTypes.map(renderItem);
        })()}
      </Menu>

      <ReassignModal {...showModal} />

      <ShareModal {...shareModal} onClose={() => setShareModal({ open: false })} actions={{}} />

      {oboOpen && oboQueue[oboIndex] && (
        <CreateModal
          key={`obo-${oboIndex}`}
          open={oboOpen}
          title={`Create ${get(oboType, 'name', singleTypeName) || 'Task'} (${oboIndex + 1} of ${oboQueue.length})`}
          checkpoint={oboQueue[oboIndex].checkpoint}
          checklist={oboQueue[oboIndex].checklist}
          realmId={realm_id}
          realmTier={realmTier}
          assessment={assessment}
          assignedTo={get(assessment, 'assignees', [me])}
          taskTypeId={get(oboType, 'id') || (singleTypeName ? get(availableTypes, '0.id') : undefined)}
          onClose={onOboClose}
        />
      )}
    </>
  );
};
